import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router-dom";
import { addEventTypeAction, getPartnerEventTypeDetailAction, updatePartnerEventTypeAction } from "../../../store/actions/partnerEventType";
import constant from "../../../util/constant";
import eventTypeConstant from "../../../util/eventTypeConstant";
import { CreateEventType } from "../../shared/eventTypes";

const { API_STATUS } = constant;
const { EVENT_TYPE_API_TYPES } = eventTypeConstant;

const AddEditEventType = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { apiType, status, partnerEventTypeDetail } = useSelector( state => ( {
    apiType: state.partnerEventType.apiType,
    status: state.partnerEventType.status,
    partnerEventTypeDetail: state.partnerEventType.partnerEventTypeDetail,
  } ) );
  const { eventTypeId } = useParams();
  const [ isEditEventType, setEditEventTypeStatus ] = useState( false );
  const [ eventTypeDetail, setEventTypeDetail ] = useState();

  useEffect( () => {
    if( eventTypeId !== "0" ) {
      setEditEventTypeStatus( true );
      dispatch( getPartnerEventTypeDetailAction( eventTypeId ) );
    }
  }, [ eventTypeId ] );

  useEffect( () => {
    if(
      status === API_STATUS.SUCCESS &&
      ( ( apiType === EVENT_TYPE_API_TYPES.ADD_EVENT_TYPE ) ||
        ( apiType === EVENT_TYPE_API_TYPES.UPDATE_PARTNER_EVENT_TYPE ) )
    ) {
      toastr.success( EVENT_TYPE_API_TYPES.ADD_EVENT_TYPE === apiType ? "Event Type added successfully" : "Event Type updated successfully" );
      history.goBack();
    }
    else if( status === API_STATUS.SUCCESS &&
      apiType === EVENT_TYPE_API_TYPES.GET_PARTNER_EVENT_TYPE_DETAIL ) {
      setEventTypeDetail( partnerEventTypeDetail );
    }
    else if( status === API_STATUS.FAILURE &&
      apiType === EVENT_TYPE_API_TYPES.GET_PARTNER_EVENT_TYPE_DETAIL ) {
      history.goBack();
    }
  }, [ apiType, status ] );

  const handleOnSave = ( values ) => {
    const requestObj = {
      // eslint-disable-next-line camelcase
      event_name: values.eventName,
      description: values.description,
      unit: values.units.value,
    };

    if( isEditEventType ) {
      // eslint-disable-next-line camelcase
      requestObj.event_type_id = eventTypeDetail.eventTypeId;
      dispatch( updatePartnerEventTypeAction( requestObj ) );
    }
    else {
      dispatch( addEventTypeAction( requestObj ) );
    }
  };

  return <CreateEventType isEditEventType={isEditEventType} eventTypeDetail={eventTypeDetail} onSave={handleOnSave} />;
};

export default AddEditEventType;
